<template>
  <div class="icon" :class="{[color || '']: true, 'outlined': outlined}">
    <i class="material-icons-outlined">{{ type == 'info' ? 'info' :
                                          type == 'success' ? 'check_circle' :
                                          type == 'warning' ? 'report_problem' :
                                          type == 'error' ? 'error_outline' :
                                          type == 'love' ? 'favorite' :
                                          name }}</i>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppIcon',
  props: {
    name: String,
    type: String,
    color: String,
    outlined: Boolean
  },
  setup() {
    return { }
  }
})
</script>

<style lang="scss" scoped>
.icon {
  height: 1em;
  width: 1em;
  border-radius: 1em;
  font-size: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    font-size: inherit !important;
    color: inherit !important;
    width: 1em;
  }

  &.primary {
    color: var(--color-primary);
  }

  &.outlined {
    font-size: 1rem;
    border: 2px solid var(--text-color-primary);
    &.success {
      border-color: var(--color-success);
      color: var(--color-success);
    }
    &.warning {
      border-color: var(--color-warning);
      color: var(--color-warning);
    }
  }
}

.router-link-exact-active .icon i {
  font-family: 'Material Icons';
  color: var(--color-primary);
}
</style>